'use client';

import { Toaster } from '@/components/ui/sonner';

export function ClientToaster() {
  return (
    <Toaster position='top-right' closeButton richColors visibleToasts={3} />
  );
}
